import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateSenderAdd from "../../Order/viewOrder/UpdateSenderAdd";
import { toast } from "react-toastify";
import { FiEdit, FiTrash2 } from "react-icons/fi"

const PickupAddress = () => {
  const [pickupAddress, setPickupAddress] = useState([]);
  const [primaryAddressId, setPrimaryAddressId] = useState(null);
  const [editData, setEditData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("Add New Address");

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const fetchPickupAddress = async () => {
    try {
      const token = document.cookie.split("=")[1];
      const response = await axios.get(`${REACT_APP_BACKEND_URL}/order/pickupAddress`, {
        headers: { authorization: `Bearer ${token}` },
      });
      setPickupAddress(response.data.data);
      const primary = response.data.data.find((item) => item.isPrimary);
      setPrimaryAddressId(primary?._id || null);
    } catch (error) {
      console.error("Error fetching pickup addresses:", error);
      toast.error("Failed to load pickup addresses");
    }
  };

  useEffect(() => {
    fetchPickupAddress();
  }, []);

  const handlePrimaryChange = async (id) => {
    try {
      const token = document.cookie.split("=")[1];
      await axios.patch(`${REACT_APP_BACKEND_URL}/order/pickupAddress/setPrimary/${id}`, {}, {
        headers: { authorization: `Bearer ${token}` },
      });
      setPrimaryAddressId(id);
      fetchPickupAddress();
      toast.success("Primary address updated");
    } catch (error) {
      console.error("Error updating primary address:", error);
      toast.error("Failed to update primary address");
    }
  };

  const handleDelete = async (id) => {
    try {
      const token = document.cookie.split("=")[1];
      await axios.delete(`${REACT_APP_BACKEND_URL}/order/pickupAddress/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      toast.success("Address deleted");
      fetchPickupAddress();
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error("Failed to delete address");
    }
  };

  const openModal = (data = null) => {
    setEditData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEditData(null);
    setIsModalOpen(false);
  };

  const handleSave = async (formData) => {
    try {
      const token = document.cookie.split("=")[1];
      if (editData && editData._id) {
        await axios.put(
          `${REACT_APP_BACKEND_URL}/order/updatePickupAddress/${editData._id}`,
          formData,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
        toast.success("Address updated successfully");
      } else {
        await axios.post(
          `${REACT_APP_BACKEND_URL}/order/pickupAddress`,
          formData,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );
        toast.success("Address added successfully");
      }
      fetchPickupAddress();
      closeModal();
    } catch (error) {
      console.error("Error saving address:", error);
      toast.error("Failed to save address");
    }
  };

  return (
    <div className="p-1 sm:p-2 space-y-2">
      <div className="flex justify-between items-center">
        <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-800">Pickup Addresses</h1>
        <button
          onClick={() => {
            openModal();
            setTitle("Add New Address");
          }}
          className="bg-[#0CBB7D] text-white text-[10px] md:text-[12px] rounded-lg font-[600] px-3 py-2"
        >
          + Add New Address
        </button>
      </div>

      {/* Table for Desktop */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 text-[12px] font-[600]">
          <thead className="bg-[#0CBB7D] text-white">
            <tr className="border border-[#0CBB7D]">
              <th className="px-3 py-2 text-left">Name</th>
              <th className="px-3 py-2 text-left">Phone</th>
              <th className="px-3 py-2 text-left">Email</th>
              <th className="px-3 py-2 text-left">Address</th>
              <th className="px-3 py-2 text-left">Primary</th>
              <th className="px-3 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {pickupAddress.map((address, index) => (
              <tr key={index} className="border text-gray-500 font-[400] text-[12px] border-gray-200">
                <td className="px-3 py-2" style={{ maxWidth: "300px", width: "250px" }}>{address.pickupAddress.contactName}</td>
                <td className="px-3 py-2" style={{ maxWidth: "300px", width: "200px" }}>{address.pickupAddress.phoneNumber}</td>
                <td className="px-3 py-2" style={{ maxWidth: "300px", width: "250px" }}>{address.pickupAddress.email}</td>
                <td className="px-3 py-2" style={{ maxWidth: "600px", width: "550px" }}>{address.pickupAddress.address}</td>
                <td className="px-3 py-2" style={{ maxWidth: "300px", width: "100px" }}>
                  <label className="inline-flex items-center cursor-pointer relative">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={primaryAddressId === address._id}
                      onChange={() => handlePrimaryChange(address._id)}
                    />
                    <div className="w-10 h-5 bg-gray-300 rounded-full peer peer-focus:outline-none peer-checked:bg-[#0CBB7D] transition-colors duration-300"></div>
                    <div className="absolute left-1 top-1 bg-white w-3 h-3 rounded-full transition-transform duration-300 transform peer-checked:translate-x-5"></div>
                  </label>
                </td>


                <td className="px-3 py-2 flex items-center gap-2 justify-center">
                  <button
                    className="p-2 rounded-full text-green-600 bg-green-100 hover:bg-green-200 transition"
                    onClick={() => {
                      openModal({ ...address.pickupAddress, _id: address._id });
                      setTitle("Edit Address");
                    }}
                  >
                    <FiEdit size={12} />
                  </button>
                  <button
                    className="p-2 rounded-full text-red-600 bg-red-100 hover:bg-red-200 transition"
                    onClick={() => handleDelete(address._id)}
                  >
                    <FiTrash2 size={12} />
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile View (Card Format) */}
      <div className="sm:hidden space-y-4">
        {pickupAddress.map((address, index) => (
          <div
            key={index}
            className="bg-white shadow rounded-lg text-gray-500 p-4 text-[10px] font-[600] space-y-1"
          >
            {/* Name, Email, Phone */}
            <div className="flex justify-between">
              <span>Name:</span>
              <span>{address.pickupAddress.contactName}</span>
            </div>
            <div className="flex justify-between">
              <span>Email:</span>
              <span>{address.pickupAddress.email}</span>
            </div>
            <div className="flex justify-between">
              <span>Phone:</span>
              <span>{address.pickupAddress.phoneNumber}</span>
            </div>

            {/* Pin Code, City, State - Each with Label */}
            <div className="flex justify-between">
              <span>Pin Code:</span>
              <span>{address.pickupAddress.pinCode}</span>
            </div>
            <div className="flex justify-between">
              <span>City:</span>
              <span>{address.pickupAddress.city}</span>
            </div>
            <div className="flex justify-between">
              <span>State:</span>
              <span>{address.pickupAddress.state}</span>
            </div>
            {/* Address - One Line, No Title */}
            <div className="font-[600]">
              {address.pickupAddress.address}
            </div>

            {/* Action Buttons + Primary Toggle */}
            <div className="flex items-center justify-between pt-2 border-t mt-2">
              {/* Action Buttons */}
              <div className="flex gap-4">
                <button
                  className="p-2 rounded-full text-green-600 bg-green-100 hover:bg-green-200 transition"
                  onClick={() => {
                    openModal({ ...address.pickupAddress, _id: address._id });
                    setTitle("Edit Address");
                  }}
                >
                  <FiEdit size={16} />
                </button>
                <button
                  className="p-2 rounded-full text-red-600 bg-red-100 hover:bg-red-200 transition"
                  onClick={() => handleDelete(address._id)}
                >
                  <FiTrash2 size={16} />
                </button>
              </div>

              {/* Primary Toggle */}
              <div className="flex items-center gap-2">
                <label className="inline-flex items-center cursor-pointer relative">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={primaryAddressId === address._id}
                    onChange={() => handlePrimaryChange(address._id)}
                  />
                  <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:outline-none peer-checked:bg-[#0CBB7D] transition-colors duration-300"></div>
                  <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300 transform peer-checked:translate-x-5"></div>
                </label>
                {/* <span className="text-[10px] text-gray-500 font-[600]">Primary</span> */}
              </div>
            </div>
          </div>
        ))}
      </div>



      {/* Modal */}
      {
        isModalOpen && (
          <UpdateSenderAdd
            isOpen={isModalOpen}
            onClose={closeModal}
            PickupAddress={editData}
            onSave={handleSave}
            title={title}
          />
        )
      }
    </div >
  );
};

export default PickupAddress;
